
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lt/sub/kurimo-irankiai",
      function () {
        return require("private-next-pages/lt/sub/kurimo-irankiai.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lt/sub/kurimo-irankiai"])
      });
    }
  